import Vue from 'vue';
import Router from 'vue-router';
import config from './config';
import Axios from 'axios';
import { store } from './store';

import Login from './views/Login.vue';
import SelectStore from './views/SelectStore'
import Dashboard from './views/Dashboard.vue';
import DashboardPro from './views/DashboardPro.vue';
import Compare from './views/Compare.vue';
import Users from './views/Users.vue';
import Orders from './views/Orders.vue';
import NotFound from './views/NotFound.vue';
import { Trans } from '@/plugins/Translation';
import Help from './views/Help.vue';
import Faq from './views/Faq.vue';
import About from './views/About.vue';
import Roles from './views/Roles.vue';
import Organizations from './views/Organizations.vue';
import Registration from './views/Registration.vue';
import Profile from './views/Profile.vue';
import { i18n } from '@/plugins/i18n';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: __dirname,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}

		return { x: 0, y: 0 };
	},
	routes: [

    {
			path: '/:lang/dashboard-pro',
			name: 'dashboardPro',
			component: DashboardPro,
			meta: {
				requiresAuth: true,
				header: true,
				footer: true
			},

		},
		{
			path: '/:lang/dashboard',
			name: 'dashboard',
			component: Dashboard,
			meta: {
				requiresAuth: true,
				header: true,
				footer: true
			},
		},
		{
			path: '/:lang/dashboard/compare',
			name: 'compare',
			component: Compare,
			meta: {
				requiresAuth: true,
				header: true,
				footer: true
			},
		},
		{
			path: '/:lang/dashboard-pro/compare',
			name: 'comparePro',
			component: Compare,
			meta: {
				requiresAuth: true,
				header: true,
				footer: true
			},
		},
		{
			path: '/:lang/orders',
			name: 'orders',
			component: Orders,
			meta: {
				requiresAuth: true,
				header: true,
				footer: true
			},
			beforeEnter: Trans.routeMiddleware
		},
		{
			path: '/:lang/users',
			name: 'users',
			component: Users,
			meta: {
				requiresAuth: true,
				header: true,
				footer: true
			},
			beforeEnter: Trans.routeMiddleware
		},
		{
			path: '/:lang/roles',
			name: 'roles',
			component: Roles,
			meta: {
				requiresAuth: true,
				header: true,
				footer: true
			},
			beforeEnter: Trans.routeMiddleware
		},
		{
			path: '/:lang/organizations',
			name: 'organizations',
			component: Organizations,
			meta: {
				requiresAuth: true,
				header: true,
				footer: true
			},
			beforeEnter: Trans.routeMiddleware
		},
		{
			path: '/:lang/registration/:id',
			name: 'registration',
			component: Registration,
			beforeEnter: Trans.routeMiddleware
		},
		{
			path: '/:lang/help',
			name: 'help',
			component: Help,
			meta: {
				requiresAuth: true,
				header: true,
				footer: true
			},
			beforeEnter: Trans.routeMiddleware
		},
		{
			path: '/:lang/faq',
			name: 'faq',
			component: Faq,
			meta: {
				requiresAuth: true,
				header: true,
				footer: true
			},
			beforeEnter: Trans.routeMiddleware
		},
		{
			path: '/:lang/about',
			name: 'about',
			component: About,
			meta: {
				requiresAuth: true,
				header: true,
				footer: true
			},
			beforeEnter: Trans.routeMiddleware
		},
		{
			path: '/:lang/select-store',
			name: 'selectStore',
			component: SelectStore,
			meta: {
				guest: true,
				header: false,
				footer: false
			},
			beforeEnter: Trans.routeMiddleware
		},
		{
			path: '/:lang/profile',
			name: 'profile',
			component: Profile,
			meta: {
				requiresAuth: true,
				header: true,
				footer: true
			},
			beforeEnter: Trans.routeMiddleware
		},
    {
			path: '/:lang',
			name: 'login',
			component: Login,
			meta: {
				guest: true,
				header: false,
				footer: false
			},
			beforeEnter: (to, from, next) => {
				Trans.routeMiddleware(to, from, next);
				if (localStorage.getItem('accessToken')) {
					next({
						path: to.path + '/orders'
					});
				}
			}
		},
		{
			path: '/404',
			component: NotFound
		},
		{
			// Redirect user to supported lang version.
			path: '/',
			/* eslint-disable */
			redirect(to) {
				if (localStorage.getItem('accessToken')) {
					return Trans.getUserSupportedLang() + '/orders';
				}
				return Trans.getUserSupportedLang();
			}
		}
	]
});

router.beforeEach((to, from, next) => {
	/* eslint-disable */
	if (!to.matched.length) {
		next('/404');
	} else {
		next();
	}
	if (to.matched.some((record) => record.meta.requiresAuth)) {
		if (localStorage.getItem('accessToken') == null) {
			next({
				path: '/'
			});
		}
	}
	if (to.matched.some(record => record.name === 'comparePro')) {
	    if (localStorage.getItem('showNewDashboardSign') !== 'true') {
            next({name: 'compare'})
	    }
	}
	if (to.matched.some(record => record.name === 'compare')) {
	    if (localStorage.getItem('showNewDashboardSign') === 'true') {
            next({name: 'comparePro'})
	    }
	}

	if (to.matched.some(record => record.name === 'dashboardPro')) {
	    if (localStorage.getItem('showNewDashboardSign') !== 'true') {
	        next({name: 'dashboard'})
	    }
	}
	if (to.matched.some(record => record.name === 'dashboard')) {
	    if (localStorage.getItem('showNewDashboardSign') === 'true') {
	        next({name: 'dashboardPro'})
	    }
	}
	if (to.matched.some(record => record.name === 'selectStore')) {
		if (Object.keys(store.getters.GET_USER_ORGANIZATIONS).length === 0) {
			next({name: 'login'})
		}
	}
	if (to.matched.some(record => record.name === 'profile')) {
		if (localStorage.getItem('userId') === '0') {
			next({name: 'login'})
		}
	}

	if (localStorage.getItem('accessToken') && localStorage.getItem('userId') !== '0') {
		Axios.get(config.apiBaseUrl + 'user', {
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		})
			.then(function(response) {
				if (response.status === 200) {
					localStorage.setItem('userName', response.data.login);
					localStorage.setItem('role', response.data.role);
					localStorage.setItem('userId', response.data.id);
					localStorage.setItem('guid', response.data.guid);
					localStorage.setItem('organization', response.data.organization);
					localStorage.setItem('organizationId', response.data.organizationId);
					localStorage.setItem('lang', i18n.locale);
					localStorage.setItem('permissions', response.data.permissions);
					localStorage.setItem('showNewDashboardSign', response.data.showNewDashboardSign);

					store.commit('SET_LOGIN_USER', response.data);
				}
			})
			.catch(function(error) {
				/* eslint-disable */
				console.log(error);
			});
	}
});

export default router;
